import React from 'react';
import styled from 'styled-components';
import { constants } from '../../constants'


/*

Props:


*/

const StyledDiv = styled.div`
  display: flex;
  justify-content: space-around;
  ${props => (props.css) ? props.css : ''}
`;

const SpaceAround = ({ styles, children, ...rest }) => (
  <StyledDiv style = {styles} {...rest}>
      { children }
  </StyledDiv>
)

export default SpaceAround



// WEBPACK FOOTER //
// ./src/js/components/Positioners/SpaceAround.jsx